import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'FormatPhone'
})
export class FormatPhonePipe implements PipeTransform {
    transform(val: string): string {
        return val.replace(/(\d{2})/g, '$1 ').replace(/(^\s+|\s+$)/, '');
    }
}
